// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdminBlockController from "./admin_block_controller"
application.register("admin-block", AdminBlockController)

import AdminHeroAnchorController from "./admin_hero_anchor_controller"
application.register("admin-hero-anchor", AdminHeroAnchorController)

import AdminSectionPaletteController from "./admin_section_palette_controller"
application.register("admin-section-palette", AdminSectionPaletteController)

import AiChipsController from "./ai_chips_controller"
application.register("ai-chips", AiChipsController)

import AnimateController from "./animate_controller"
application.register("animate", AnimateController)

import AnnouncementSettingsController from "./announcement_settings_controller"
application.register("announcement-settings", AnnouncementSettingsController)

import AssistantProgressController from "./assistant_progress_controller"
application.register("assistant-progress", AssistantProgressController)

import AssistantSheetController from "./assistant_sheet_controller"
application.register("assistant-sheet", AssistantSheetController)

import AttachmentLightboxController from "./attachment_lightbox_controller"
application.register("attachment-lightbox", AttachmentLightboxController)

import AutoScrollController from "./auto_scroll_controller"
application.register("auto-scroll", AutoScrollController)

import BackgroundImageSortablesController from "./background_image_sortables_controller"
application.register("background-image-sortables", BackgroundImageSortablesController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChatLayoutController from "./chat_layout_controller"
application.register("chat-layout", ChatLayoutController)

import ChatSearchController from "./chat_search_controller"
application.register("chat-search", ChatSearchController)

import ClassroomsRolesController from "./classrooms_roles_controller"
application.register("classrooms-roles", ClassroomsRolesController)

import ColumnSortablesController from "./column_sortables_controller"
application.register("column-sortables", ColumnSortablesController)

import ComposerAutosizeController from "./composer_autosize_controller"
application.register("composer-autosize", ComposerAutosizeController)

import ComposerDropController from "./composer_drop_controller"
application.register("composer-drop", ComposerDropController)

import DocumentSortablesController from "./document_sortables_controller"
application.register("document-sortables", DocumentSortablesController)

import DropAttachmentsController from "./drop_attachments_controller"
application.register("drop-attachments", DropAttachmentsController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import EditHistoryController from "./edit_history_controller"
application.register("edit-history", EditHistoryController)

import EditableTextController from "./editable_text_controller"
application.register("editable-text", EditableTextController)

import EmojiPickerController from "./emoji_picker_controller"
application.register("emoji-picker", EmojiPickerController)

import FlatpickrController from "./flatpickr_controller"
application.register("flatpickr", FlatpickrController)

import GroupChatFormController from "./group_chat_form_controller"
application.register("group-chat-form", GroupChatFormController)

import ImageCroppersController from "./image_croppers_controller"
application.register("image-croppers", ImageCroppersController)

import LayoutPickerController from "./layout_picker_controller"
application.register("layout-picker", LayoutPickerController)

import LogoPreviewController from "./logo_preview_controller"
application.register("logo-preview", LogoPreviewController)

import LogoStylingController from "./logo_styling_controller"
application.register("logo-styling", LogoStylingController)

import MarkdownEditorController from "./markdown_editor_controller"
application.register("markdown-editor", MarkdownEditorController)

import MessageController from "./message_controller"
application.register("message", MessageController)

import MessageEditController from "./message_edit_controller"
application.register("message-edit", MessageEditController)

import MessageFormController from "./message_form_controller"
application.register("message-form", MessageFormController)

import MessagesContainerController from "./messages_container_controller"
application.register("messages-container", MessagesContainerController)

import MoveRowsController from "./move_rows_controller"
application.register("move-rows", MoveRowsController)

import NavbarController from "./navbar_controller"
application.register("navbar", NavbarController)

import NavbarScrollController from "./navbar_scroll_controller"
application.register("navbar-scroll", NavbarScrollController)

import NavigableSubPagesController from "./navigable_sub_pages_controller"
application.register("navigable-sub-pages", NavigableSubPagesController)

import NewRowsController from "./new_rows_controller"
application.register("new-rows", NewRowsController)

import NewsletterArticleSortablesController from "./newsletter_article_sortables_controller"
application.register("newsletter-article-sortables", NewsletterArticleSortablesController)

import NotificationsController from "./notifications_controller"
application.register("notifications", NotificationsController)

import PageLayoutPickerController from "./page_layout_picker_controller"
application.register("page-layout-picker", PageLayoutPickerController)

import PageLayoutSelectController from "./page_layout_select_controller"
application.register("page-layout-select", PageLayoutSelectController)

import PageSortablesController from "./page_sortables_controller"
application.register("page-sortables", PageSortablesController)

import PickrController from "./pickr_controller"
application.register("pickr", PickrController)

import PopoverController from "./popover_controller"
application.register("popover", PopoverController)

import ReactionController from "./reaction_controller"
application.register("reaction", ReactionController)

import RowSortablesController from "./row_sortables_controller"
application.register("row-sortables", RowSortablesController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import SidebarController from "./sidebar_controller"
application.register("sidebar", SidebarController)

import SlideAssistantController from "./slide_assistant_controller"
application.register("slide-assistant", SlideAssistantController)

import SlideOversController from "./slide_overs_controller"
application.register("slide-overs", SlideOversController)

import SlideSettingsController from "./slide_settings_controller"
application.register("slide-settings", SlideSettingsController)

import SlideSortablesController from "./slide_sortables_controller"
application.register("slide-sortables", SlideSortablesController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SubPagesExpandableController from "./sub_pages_expandable_controller"
application.register("sub-pages-expandable", SubPagesExpandableController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)

import TypingIndicatorController from "./typing_indicator_controller"
application.register("typing-indicator", TypingIndicatorController)

import TypingTrackerController from "./typing_tracker_controller"
application.register("typing-tracker", TypingTrackerController)

import WebPushController from "./web_push_controller"
application.register("web-push", WebPushController)

import WebsiteSettingsTabsController from "./website_settings_tabs_controller"
application.register("website-settings-tabs", WebsiteSettingsTabsController)
